import { connect } from 'react-redux';
import { branch, compose, pure, renderComponent, mapProps } from 'recompose';
import { injectIntl } from 'react-intl';

import orderBy from 'lodash/orderBy';

import requestsStatuses from 'modules/common/constants/requestsStatuses';

import ConversationsTab from './ConversationsTab';
import TabContentPending from '../_placeholders/TabContentPending';

const mapStateToProps = (state) => ({
  conversationItems: state.appointmentInfo.currentAppointment.conversations,
});

export default compose(
  connect(mapStateToProps),
  injectIntl,
  pure,
  branch(
    ({ status }) => status === requestsStatuses.pending,
    renderComponent(TabContentPending),
  ),
  mapProps(({ conversationItems, ...rest }) => ({
    ...rest,
    conversationItems: orderBy(conversationItems, ['start', 'end'], 'desc'),
  })),
)(ConversationsTab);
